import { formatUsdFromCents } from "./CurrencyUtils";

export const formatGigCompensation = (
  paymentAmountCents: number | null | undefined,
  volunteer: boolean | null | undefined,
  fallback = "Not available",
): string => {
  if (volunteer) {
    return "Volunteer";
  }

  if (paymentAmountCents === null || paymentAmountCents === undefined) {
    return fallback;
  }

  return formatUsdFromCents(paymentAmountCents, fallback);
};

export const formatTeenGigCompensation = (
  paymentAmountCents: number | null | undefined,
  volunteer: boolean | null | undefined,
  fallback = "Not available",
): string => {
  if (volunteer) {
    return "Volunteer";
  }

  if (paymentAmountCents === null || paymentAmountCents === undefined) {
    return fallback;
  }

  const roundedDisplayCents = Math.floor(Math.max(0, paymentAmountCents) / 50) * 50;
  const formattedAmount = formatUsdFromCents(roundedDisplayCents, fallback);
  return roundedDisplayCents % 100 === 0 ? formattedAmount.replace(".00", "") : formattedAmount;
};

export const formatRoundedGigCompensation = formatTeenGigCompensation;
